export default {
  data() {
    return {
      // eslint-disable-next-line
      facilitySearchPrivacy: [
        "Public",
        "Private"
      ],
      // eslint-disable-next-line
      facilityViewOptions: [
        "Business",
        "Supervisor"
      ],
      facilityAssetRegisterLimit: ["1", "5", "10", "15", "20", "25"],
      facilityAuthLevelDataLimit: ["2", "3", "4", "5"],
      // eslint-disable-next-line
      facilityStructure: [
        "Operator",
        "Owner",
        "Owner Operator",
        "Director",
        "Management",
        "Corporate"
      ],
      facilitySection: [],
      facilityArea: [],
      facilityUnit: ["A", "B"],
      facilitySystem: [
        "Acid Mixing",
        "Cooling",
        "Dehydration",
        "Diesel Distribution",
        "Emissions Control",
        "Heating",
        "Fuel Gas",
        "Fuel Liquid",
        "Gas Compression",
        "Gas Injection",
        "Instrument Air",
        "Nitrogen System",
        "LNG Storage",
        "LPG Storage",
        "Power Generation",
        "Power Distribution",
        "Rock Crushing",
        "Water Storage"
      ],
      facilitySystems: [],
      // eslint-disable-next-line
      facilityThemeOptions: [
        "Agricultural",
        "Commercial",
        "Entertainment",
        "Educational",
        "Government",
        "Industrial",
        "Major Hazard",
        "Medical",
        "Other",
        "Residential",
        "Transport"
      ],
      // eslint-disable-next-line
      facilityTypeOptions: [
        "Airport",
        "Amusement Park",
        "Apartment Block",
        "Area",
        "Base",
        "Block",
        "Building",
        "Compressor Station",
        "Control Centre",
        "Depot",
        "Desalination Plant",
        "District",
        "Docks",
        "Factory",
        "Farm",
        "Fast Food",
        "Ferry Terminal",
        "Fire Station",
        "Gas Plant",
        "Government Building",
        "Historical Building",
        "House",
        "Housing Estate",
        "Hotel",
        "Hospital",
        "LPG Plant",
        "LNG Plant",
        "Office",
        "Offshore Platform",
        "Oil Refinery",
        "Manufacturing Plant",
        "Marine",
        "Medical Site",
        "Mine",
        "Museum",
        "National Park",
        "Petrol Station",
        "Police Station",
        "Power Station",
        "Pump Station",
        "Railway Station",
        "Remote Control Station",
        "Restaurant",
        "School",
        "Sewage Plant",
        "Sea Port",
        "Ship",
        "Shop",
        "Shopping Mall",
        "Stadium",
        "System",
        "Suburb",
        "Substation",
        "Terminal",
        "Train",
        "Tunnel",
        "Unit",
        "University",
        "Warehouse",
        "Worship",
        "Wind Farm",
        "Zoo",
        "Other"
      ],
      // eslint-disable-next-line
      facilityObjective: [
        "Logistic",
        "Production",
        "Service",
        "Social"
      ],
      // eslint-disable-next-line
      facilityMobility: [
        "Fixed",
        "Mobile"
      ],
      // eslint-disable-next-line
      facilityLocation: [
        "Mobile",
        "Offshore",
        "Onshore",
        "Vessel"
      ],
      // eslint-disable-next-line
      facilitySearchPrivacy: [
        "Confidential",
        "Public",
        "Restricted"
      ]
    };
  }
};
